var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_423)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3488 0.511784C12.1402 0.362771 11.8599 0.362771 11.6513 0.511784L0.651282 8.36893C0.493604 8.48155 0.400024 8.6634 0.400024 8.85717V23C0.400024 23.3314 0.668654 23.6 1.00002 23.6H23C23.3314 23.6 23.6 23.3314 23.6 23C23.6 22.6687 23.3314 22.4 23 22.4H18.0001V15C18.0001 14.6687 17.7314 14.4 17.4001 14.4H13.8001C13.4687 14.4 13.2001 14.6687 13.2001 15V22.4H1.60002V9.60003H22.4V19.3334C22.4 19.6647 22.6687 19.9334 23 19.9334C23.3314 19.9334 23.6 19.6647 23.6 19.3334V8.85717C23.6 8.6634 23.5064 8.48155 23.3488 8.36893L12.3488 0.511784ZM14.4001 22.4H16.8001V15.6H14.4001V22.4ZM21.3277 8.40002L12 1.73737L2.67231 8.40002H21.3277Z",
    fill: "#383634"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90002 15C5.90002 14.6687 6.16865 14.4 6.50002 14.4H10.1C10.4314 14.4 10.7 14.6687 10.7 15V18.6C10.7 18.9314 10.4314 19.2 10.1 19.2H6.50002C6.16865 19.2 5.90002 18.9314 5.90002 18.6V15ZM7.10002 15.6V18H9.50002V15.6H7.10002Z",
    fill: "#383634"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/house_icon.cdc6212a4da51f42ccd0296814c95a70.svg";
export { ForwardRef as ReactComponent };